import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from 'components/ui/use-toast';
import * as Api from '../api';
import * as Types from '../types';
import { useUndoDelete } from 'modules/trash';

const useDelete = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const { t } = useTranslation();
  const undoable = useUndoDelete();

  return useMutation({
    mutationFn: (data: Types.IMutation.Delete) => Api.Delete({ id: data.id }),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['test', 'list'] });
      undoable({ type: 'test', ids: [variables.id], title: t('trash.deleted_test') });
    },
    onError: (error: any) => {
      toast.error(t('error'), {
        description: error?.response?.data?.message || t('failed_to_delete_test'),
      });
    },
  });
};

export default useDelete;
